import React from "react";
import { Route, Redirect } from "react-router-dom";

import { isAuthenticated } from "Services/Authentication";

const PublicRoute = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Redirect
            to={{
              pathname: "/boas-vindas",
              state: {
                from: props.location,
              },
            }}
          />
        ) : (
          <Layout {...rest}>
            <Component {...props} />
          </Layout>
        )
      }
    />
  );
};

export default PublicRoute;
